/**
 * The Biler export (#869 AC2): one row per organisation, the table's columns
 * in the table's order, with the values formatted as the table shows them.
 * The headings reuse the table's own keys so the two cannot drift apart.
 */
import type { TFunction } from 'i18next'
import type { ColumnDefinition } from '../../utils/exportToCsv'
import { formatNorwegianDate } from '../../utils/dateUtils'

/** The same cap as the "1000+" count (COUNT_CAP on the backend). Over 200
 *  the endpoint requires leads_table_exporter. */
export const BILER_EXPORT_LIMIT = 1000

const dash = (v: string | null | undefined) => v ?? '—'
const date = (v: string | null | undefined) => (v ? formatNorwegianDate(v) : '—')

export function bilerExportColumns(t: TFunction<'leads'>): ColumnDefinition[] {
  return [
    { key: 'navn', label: t('common.bedrift'), format: dash },
    { key: 'org_nr', label: t('common.orgNr') },
    { key: 'car_count', label: t('biler.carsInHit') },
    { key: 'leased_count', label: t('biler.ofWhichLeased') },
    { key: 'oldest_reg', label: t('biler.oldest'), format: date },
    { key: 'newest_reg', label: t('biler.newest'), format: date },
    { key: 'postnummer', label: t('common.postnr'), format: dash },
  ]
}
